import React from 'react'
import { useHistory, useParams } from 'react-router-dom'
import clsx from 'clsx'
import dayjs from 'dayjs'

import { Checkbox, DashboardLayout, Icon, Loader } from '../../components'
import './Notifications.scss'
import Notification from './Notification'
import { isDesktop } from '../../utils'
import { useDispatch, useSelector } from 'react-redux'
import {
   deleteNotifications,
   markAllRead,
   markRead,
} from '../../store/notifications'

const Notifications = () => {
   const history = useHistory()
   const { notificationId } = useParams()
   const dispatch = useDispatch()
   const { isDarkTheme } = useSelector(state => state.theme)
   const { notifications } = useSelector(state => state.notifications)

   const [fetchedNotification, setFetchedNotification] = React.useState(null)
   const [selected, setSelected] = React.useState([])
   const [isLoading, setIsLoading] = React.useState(true)

   const [selectedNotification, setSelectedNotification] = React.useState()

   React.useEffect(() => {
      if (selectedNotification) {
         dispatch(markRead(selectedNotification.id))
      }
   }, [selectedNotification, dispatch])

   React.useEffect(() => {
      try {
         if (notificationId && !isDesktop()) {
            // fetch single notification
            const foundNotification = notifications.find(
               n => n.id === notificationId
            )
            setFetchedNotification(foundNotification)
         } else {
            // fetch all notifications
            // dispatch from here after fetching
         }
      } catch (err) {
         console.log(err)
      } finally {
         setIsLoading(false)
      }
   }, [notificationId])

   const toggleCheckbox = touchedId => {
      const index = selected.findIndex(id => id === touchedId)
      const updatedSelected = [...selected]
      if (~index) {
         updatedSelected.splice(index, 1)
      } else {
         updatedSelected.push(touchedId)
      }
      setSelected(updatedSelected)
   }

   if (isDesktop()) {
      return (
         <DashboardLayout>
            {isLoading ? (
               <Loader />
            ) : (
               <div
                  className={clsx(
                     'DesktopNotifications',
                     isDarkTheme && 'DesktopNotifications--dark'
                  )}
               >
                  <div className="DesktopNotifications__actions">
                     <Icon
                        name="check-double"
                        className="DesktopNotifications__actions-icon"
                        onClick={() => dispatch(markAllRead())}
                     />
                     <Icon
                        name="trash"
                        className="DesktopNotifications__actions-icon"
                        onClick={() => dispatch(deleteNotifications(selected))}
                     />
                  </div>
                  <div className="DesktopNotifications__grid">
                     <div className="DesktopNotifications__selected">
                        {selectedNotification ? (
                           <>
                              <h3 className="DesktopNotifications__selected-heading">
                                 {selectedNotification.heading}
                              </h3>
                              <p className="DesktopNotifications__selected-description">
                                 {selectedNotification.description}
                              </p>
                              <p className="DesktopNotifications__selected-description">
                                 {selectedNotification.metadata}
                              </p>
                           </>
                        ) : (
                           <h3> No notification selected. </h3>
                        )}
                     </div>
                     <div className="DesktopNotifications__list">
                        {notifications.map(notification => (
                           <div
                              className="DesktopNotifications__list-card"
                              key={notification.id}
                              role="button"
                              tabIndex={0}
                              onClick={() =>
                                 setSelectedNotification(notification)
                              }
                           >
                              <div className="DesktopNotifications__list-card-top">
                                 <span
                                    className={clsx(
                                       'DesktopNotifications__list-card-top-blinker',
                                       notification.isRead &&
                                          'DesktopNotifications__list-card-top-blinker--read'
                                    )}
                                 />
                                 {notification.heading}
                              </div>
                              <div className="DesktopNotifications__list-card-bottom">
                                 <Checkbox
                                    className="DesktopNotifications__list-card-bottom-checkbox"
                                    checked={selected.includes(notification.id)}
                                    onChange={() =>
                                       toggleCheckbox(notification.id)
                                    }
                                    onClick={e => e.stopPropagation()}
                                 />
                                 {notification.description}
                              </div>
                              <div className="DesktopNotifications__list-card-time">
                                 {dayjs(notification.createdAt).format(
                                    'YYYY-MM-DD HH:MM'
                                 )}
                              </div>
                           </div>
                        ))}
                     </div>
                  </div>
               </div>
            )}
         </DashboardLayout>
      )
   }

   if (isLoading) return <Loader />
   if (notificationId && fetchedNotification)
      return <Notification notification={fetchedNotification} />
   return (
      <div
         className={clsx('Notifications', isDarkTheme && 'Notifications--dark')}
      >
         <div className="Notifications__top">
            <Icon
               name="chevron-left"
               className="Notifications__top-icon"
               onClick={() => history.goBack()}
            />
            <div className="Notifications__actions">
               <Icon
                  name="check-double"
                  className="Notifications__actions-icon"
                  onClick={() => dispatch(markAllRead())}
               />
               <Icon
                  name="trash"
                  className="Notifications__actions-icon"
                  onClick={() => dispatch(deleteNotifications(selected))}
               />
            </div>
         </div>
         <div className="Notifications__list">
            {notifications.map(notification => (
               <div
                  className="Notifications__list-card"
                  key={notification.id}
                  role="button"
                  tabIndex={0}
                  onClick={() =>
                     history.push(`/notifications/${notification.id}`)
                  }
               >
                  <div className="Notifications__list-card-top">
                     <span
                        className={clsx(
                           'Notifications__list-card-top-blinker',
                           notification.isRead &&
                              'Notifications__list-card-top-blinker--read'
                        )}
                     />
                     {notification.heading}
                  </div>
                  <div className="Notifications__list-card-bottom">
                     <Checkbox
                        className="Notifications__list-card-bottom-checkbox"
                        checked={selected.includes(notification.id)}
                        onChange={() => toggleCheckbox(notification.id)}
                        onClick={e => e.stopPropagation()}
                     />
                     {notification.description}
                  </div>
                  <div className="Notifications__list-card-time">
                     {dayjs(notification.createdAt).format('YYYY-MM-DD HH:MM')}
                  </div>
               </div>
            ))}
         </div>
      </div>
   )
}

export default Notifications
